<template>
  <div>
    <van-swipe
      v-if="swipeShow"
      class="notices-container"
      :autoplay="config.duration>0 ? config.duration : 3000"
      :show-indicators="false"
      indicator-color="white"
    >
      <van-swipe-item
        v-for="notice in notices"
        :key="notice.id"
      >
        <ShowNoticeBar
          :slug="slug"
          :notice-data="notice"
          :scrollable="config.scrollable"
        />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
  import ShowNoticeBar from './show-notice-bar.vue'
  import { Swipe, SwipeItem } from 'vant'
  import Vue from 'vue'
  Vue.use(Swipe, SwipeItem)

  export default {
    name: "BlockNotice",
    components: {
      ShowNoticeBar
    },
    data () {
      return {
        slug: '', // show 的 slug
        notices: [], // 未隐藏的节目公告
        config: {}, // 设置
        swipeShow: true
      }
    },
    methods: {
      getNoticeConfig: function () {
        let that = this
        let params = {
          show__slug: that.slug
        }
        that.$api.noticeConfig.list(params).then(res => {
          // window.console.log("获取到 notice config")
          // window.console.log(res)
          if (res.data.count > 0) {
            if (res.data.results[0].enable) {
              // window.console.log("Notice区块已启用")
              that.getNotices()
              that.config = res.data.results[0]
            } else {
              // window.console.log("Notice区块已禁用")
            }
          } else {
            // window.console.log("未找到相关配置")
          }
        })
      },
      getNotices: function () {
        let that = this
        let params = {
          slug: that.slug,
          hidden: false
        }
        that.$api.notice.list(params).then(res => {
          // window.console.log("获取到未隐藏的 Notice 列表")
          // window.console.log(res)
          that.notices = res.data.results
        })
      }
    },
    watch: {
      // 横向跑马灯 notice-bar 有一个 bug
      // 切到别的页面再切回来就会不显示
      // 这里监听切换状态，再重新显示此区块可规避此 bug
      $route(to, from){
        if (from != to && from.name == 'Discovery') {
          this.swipeShow = false
        }
        if (to != from && to.name == 'Discovery') {
          this.swipeShow = true
        }
      }
    },
    mounted () {
      this.slug = this.$route.params.slug
      this.getNoticeConfig()
      // window.console.log("组件被加载")
    },
    destroyed () {
      // window.console.log("组件被销毁")
    }
  }
</script>

<style lang="css" scoped>
</style>
